// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__SNjjB","home__pictures":"Home_home__pictures__z0jkt","home__content":"Home_home__content__oMXsB"};